import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import type { Toast, ToastAction } from '@catch/libs';
import { ToastType } from '@catch/libs';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faSync,
  faTimes,
} from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  standalone: true,
  selector: 'ct-lib-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [FaIconComponent, TranslocoPipe],
  host: {
    class: 'd-block mb-3',
  },
})
export class ToastComponent implements OnInit {
  @Input() public toast: Toast;
  @Input() public duration = 5000;
  @Input() public fixed = false;
  @Output() public onDestroy: EventEmitter<Toast> = new EventEmitter();
  public destroyPause = false;
  private destroyCounter = 0;
  private intervalStep = 200;
  private destroyInterval: any;
  faInfoCircle = faInfoCircle;
  faCheckCircle = faCheckCircle;
  faExclamationCircle = faExclamationCircle;
  faExclamationTriangle = faExclamationTriangle;
  faTimes = faTimes;
  faSync = faSync;

  

  ngOnInit(): void {
    if (
      this.toast.type === ToastType.ALERT ||
      this.toast.type === ToastType.INFO
    )
      this.duration *= 2; // show INFO and ALERT for longer time
    if (!this.fixed && !this.toast.persistent) {
      this.destroyInterval = setInterval(() => {
        if (!this.destroyPause) {
          this.destroyCounter += this.intervalStep;
        }
        if (this.destroyCounter >= this.duration) {
          this.destroy();
        }
      }, this.intervalStep); //SASCHA Kann man das hier besser lösen (Ohne setInterval)
    }
  }

  executeAction(action: ToastAction) {
    action.action();
  }

  destroy() {
    clearInterval(this.destroyInterval);
    this.onDestroy.emit(this.toast);
  }
}
